import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import OwnerLayout from "@/components/owner/OwnerLayout";
import PropertyForm from "@/components/property/PropertyForm";

export default function PropertyNewPage() {
  return (
    <OwnerLayout testid="property-new-page">
      <Link to="/owner/properties" className="inline-flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-primary transition-colors mb-4" data-testid="new-back-link">
        <ArrowLeft size={16} /> Property Saya
      </Link>
      <h1 className="font-heading text-3xl font-bold tracking-tight mb-6">Tambah Property</h1>
      <PropertyForm mode="create" />
    </OwnerLayout>
  );
}
